import axios from 'axios';

export const getAllHouses = (token) => {
    return new Promise((resolve, reject) => {
        axios
            .get('user/getallhouses', {
                headers: {
                    Authorization: `${token}`,
                },
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

/** Get all properties (houses/apartments) for the authenticated user. */
export const getAllProperties = (token) => {
    return new Promise((resolve, reject) => {
        axios
            .get('user/getallproperties', {
                headers: {
                    Authorization: `${token}`,
                },
            })
            .then((response) => {
                console.log(response.data);
                resolve(response.data);

            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('username');
                    delete axios.defaults.headers.common.Authorization;
                    if (window.location.pathname !== '/signin') {
                        window.location.replace('/signin');
                    }
                }
                reject(error);
            });
    });
};

/** Get all houses (apartments) for a building from the building-scoped endpoint. */
//  TODO Replace dev URL with production URL
export const getBuildingHouses = (buildingId) => {
    return new Promise((resolve, reject) => {
        if (!buildingId) {
            resolve([]);
            return;
        }
        axios
            .get(`building/getallhouses/${buildingId}`)
            .then((response) => {
                resolve(Array.isArray(response.data) ? response.data : []);
            })
            .catch(reject);
    });
};

export const getHousePeriodicConsumptions = (period, houseId) => {
    // const buildFallbackSeries = () => {
    //     const now = new Date();
    //     const toIso = (d) => d.toISOString().slice(0, 10);
    //     let dates = [];

    //     if (typeof period === 'string' && period.startsWith('period/')) {
    //         const [, from, to] = period.split('/');
    //         const start = new Date(from);
    //         const end = new Date(to);
    //         if (!Number.isNaN(start.getTime()) && !Number.isNaN(end.getTime()) && start <= end) {
    //             const cursor = new Date(start);
    //             while (cursor <= end) {
    //                 dates.push(toIso(cursor));
    //                 cursor.setDate(cursor.getDate() + 1);
    //             }
    //         }
    //     }

    //     if (!dates.length) {
    //         const days = period === 'lastmonth' ? 30 : 7;
    //         dates = Array.from({ length: days }, (_, idx) => {
    //             const d = new Date(now);
    //             d.setDate(now.getDate() - (days - 1 - idx));
    //             return toIso(d);
    //         });
    //     }

    //     const consumption = dates.map((_, i) => Number((2.2 + (i % 6) * 0.65).toFixed(2)));
    //     return { labels: dates, consumption };
    // };

    return new Promise((resolve, reject) => {
        axios
            .get(`data/${period}/${houseId}`)
            .then((response) => {
                resolve(response.data)
            })
            .catch(reject);
    });
};

/** Cost for a date range (last week, last month, or custom). Returns { cumulative, periods }. */
export const getHouseCostByPeriod = (startDate, endDate, houseId) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`data/cost/period/${startDate}/${endDate}/${houseId}`)
            .then((response) => {
                console.log(response.data);
                resolve(response.data);
            })
            .catch(reject);
    });
};

export const getHouseBillingInfo = (houseId) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`data/cost/currentmonth/${houseId}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch(reject);
    });
};

export const getHouseCostHistory = (houseId) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`data/cost/history/${houseId}`)
            .then((response) => {
                resolve(response.data)
            })
            .catch(reject);
    });
};

export const getHouseInsights = (houseId) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`data/insights/${houseId}`)
            .then((response) => {
                console.log(response.data);
                resolve(response.data)
            })
            .catch(reject);
    });
};

export const getHouseEntity = (houseId) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`house/get/${houseId}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch(reject);
    });
};

export const updateHouse = (houseId, house) => {
    return new Promise((resolve, reject) => {
        axios
            .put(`/house/update/${houseId}`, house)
            .then((response) => {
                resolve(response.data);
            })
            .catch(reject);
    });
};
